const wicLoftLoader = () => {
	const page_body = document.querySelector('body');	
	let data = {};

	data.show = () => {
		page_body.classList.remove('loaded', 'loftloader-loaded');
	}

	data.hide = () => {
		page_body.classList.add('loaded', 'loftloader-loaded');
	}

	return data;
}